import { DetailSectionHeading } from "../detail/DetailAccentCard";

export default function EditorFieldSection({
	title,
	description,
	children,
	className = "",
}) {
	return (
		<section
			className={`rounded-[14px] border border-darkBlue/8 bg-lightCta/25 p-4 md:p-5 ${className}`}
		>
			{title && <DetailSectionHeading className="mb-1">{title}</DetailSectionHeading>}
			{description && (
				<p className="mb-4 font-Vazir-400 text-[13px] leading-relaxed text-darkBlue/55">
					{description}
				</p>
			)}
			<div className="flex flex-col gap-4">{children}</div>
		</section>
	);
}
